// ─────────────────────────────────────────────────────────────────────────────
// components.tsx — Shared primitives for ContentSectionEditPageCareer
// ─────────────────────────────────────────────────────────────────────────────
import React, { useState } from 'react';
import { Toggle } from '@core/uilibrary';
import TextFieldInline from '../../../../../../component-controller-mod/component-serv/input-fs-cp/text-field-op/ts/textFieldInline';
import TextAreaInline from '../../../../../../component-controller-mod/component-serv/input-fs-cp/textarea-field-op/ts/textAreaInline';

// ─────────────────────────────────────────────────────────────────────────────
// DraftTextField
// ─────────────────────────────────────────────────────────────────────────────

export const DraftTextField: React.FC<{
  initialValue?: string;
  placeholder?:  string;
  onChange:      (v: string) => void;
}> = ({ initialValue = '', placeholder, onChange }) => {
  const [draft, setDraft] = useState(initialValue);
  return (
    <TextFieldInline
      value={draft}
      placeholder={placeholder}
      onChange={(v: string) => { setDraft(v); onChange(v); }}
    />
  );
};

// ─────────────────────────────────────────────────────────────────────────────
// DraftTextArea
// ─────────────────────────────────────────────────────────────────────────────

export const DraftTextArea: React.FC<{
  initialValue?: string;
  placeholder?:  string;
  rows?:         number;
  onChange:      (v: string) => void;
}> = ({ initialValue = '', placeholder, rows, onChange }) => {
  const [draft, setDraft] = useState(initialValue);
  return (
    <TextAreaInline
      value={draft}
      placeholder={placeholder}
      rows={rows}
      onChange={(v: string) => { setDraft(v); onChange(v); }}
    />
  );
};

// ─────────────────────────────────────────────────────────────────────────────
// LabelRow
// ─────────────────────────────────────────────────────────────────────────────

export const LabelRow: React.FC<{
  label:     string;
  required?: boolean;
  toggle?:   { checked: boolean; onChange: (v: boolean) => void };
}> = ({ label, required, toggle }) => (
  <div className="scl--cms-content-edit-career-label-row">
    <span
      className="scl--cms-content-edit-career-label"
      style={toggle ? { fontWeight: 600 } : undefined}
    >
      {label}{required && <span className="scl--cms-content-edit-career-required"> *</span>}
    </span>
    {toggle && <Toggle checked={toggle.checked} onChange={toggle.onChange} />}
  </div>
);

// ─────────────────────────────────────────────────────────────────────────────
// SplitRow
// ─────────────────────────────────────────────────────────────────────────────

export const SplitRow: React.FC<{
  currentText: string;
  multiline?:  boolean;
  children:    React.ReactNode;
}> = ({ currentText, multiline, children }) => (
  <div className={`scl--cms-content-edit-career-split-row${multiline ? ' scl--cms-content-edit-career-split-row--multiline' : ''}`}>
    <div className="scl--cms-content-edit-career-split-accent" />
    <div className="scl--cms-content-edit-career-split-body">
      <span className="scl--cms-content-edit-career-split-current">{currentText}</span>
      <div className={`scl--cms-content-edit-career-split-slot${multiline ? ' scl--cms-content-edit-career-split-slot--textarea' : ''}`}>
        {children}
      </div>
    </div>
  </div>
);